<!-- =========================
     MOBILE HEADER
========================= -->


<div class="mobile-header">

  <!-- LEFT -->
<button
  type="button"
  class="menu-btn"
  (click)="toggleSidebar()"
>
    <i class="fa-solid fa-bars"></i>
  </button>

  <!-- CENTER -->
  <div
    class="mobile-brand"
    (click)="goHome()"
  >
    <img
      [src]="logoUrl"
      class="brand-logo"
      alt="Super Bangladesh"
      (error)="onLogoError()"
    >

  </div>

  <!-- RIGHT -->
<div class="mobile-actions">

  <div class="mobile-language-switch">

    <span
      [class.active]="selectedLanguage === 'en'"
      (click)="changeLanguage('en')">
      EN
    </span>

    <span class="divider">/</span>

    <span
      [class.active]="selectedLanguage === 'bn'"
      (click)="changeLanguage('bn')">
      বাং
    </span>

  </div>

</div>

</div>

<!-- =========================
     MOBILE LOCATION BAR
========================= -->

<div
  class="mobile-location-bar"
  (click)="toggleLocationMenu($event)"
>
  <i class="fa-solid fa-location-dot"></i>

  <span>
    {{ getSelectedLocationLabel() }}
  </span>

  <i class="fa-solid fa-chevron-down"></i>
</div>

<div
  class="auto-location-confirm"
  *ngIf="showAutoLocationConfirm && !showLocationMenu"
  (click)="$event.stopPropagation()"
>
  <span>{{ t('autoLocationConfirmText') }} <strong>{{ getSelectedLocationLabel() }}</strong>?</span>

  <div class="auto-location-confirm-actions">
    <button type="button" (click)="dismissAutoLocationConfirm($event)">
      {{ t('yesCorrect') }}
    </button>
    <button type="button" class="fix" (click)="fixAutoLocation($event)">
      {{ t('notMyArea') }}
    </button>
  </div>
</div>

<div
  class="mobile-overlay"
  *ngIf="showLocationMenu"
  (click)="toggleLocationMenu($event)"
>
</div>

<div
  class="mobile-location-dropdown"
  *ngIf="showLocationMenu"
  (click)="$event.stopPropagation()"
>

  <!-- STEP 1: MAIN -->
  <ng-container *ngIf="locationMenuStep === 'main'">

    <button
      type="button"
      class="location-option"
      (click)="useCurrentLocationNavbar()"
      [disabled]="locatingCurrentLocation"
    >
      <i class="fa-solid fa-location-crosshairs"></i>

      <span *ngIf="!locatingCurrentLocation">
        {{ t('useMyLocation') }}
      </span>

      <span *ngIf="locatingCurrentLocation">
        {{ t('locatingYou') }}
      </span>
    </button>

    <button
      type="button"
      class="location-option"
      (click)="showCityList()"
    >
      <i class="fa-solid fa-circle city-dot-icon"></i>
      <span>{{ t('changeCity') }}</span>
    </button>

  </ng-container>

  <!-- STEP 2: CITY LIST -->
  <ng-container *ngIf="locationMenuStep === 'cities'">

    <button
      type="button"
      class="location-back"
      (click)="backToLocationMain()"
    >
      <i class="fa-solid fa-arrow-left"></i>
    </button>

    <div class="location-search-box">
      <i class="fa-solid fa-magnifying-glass"></i>
      <input
        type="text"
        [(ngModel)]="locationSearchText"
        (input)="onLocationSearchInput()"
        [placeholder]="t('searchYourArea')"
      />
    </div>

    <ng-container *ngIf="locationSearchText.trim().length >= 3">

      <div class="location-search-status" *ngIf="locationSearching">
        {{ t('searchingLocation') }}
      </div>

      <ng-container *ngIf="!locationSearching">

        <button
          type="button"
          class="location-search-result"
          *ngFor="let result of locationSearchResults"
          (click)="selectSearchResult(result)"
        >
          <i class="fa-solid fa-location-dot"></i>
          <span>{{ result.label }}</span>
        </button>

        <div
          class="location-search-status"
          *ngIf="locationSearchResults.length === 0"
        >
          {{ t('noLocationResults') }}
        </div>

      </ng-container>

    </ng-container>

    <ng-container *ngIf="locationSearchText.trim().length < 3">

      <div class="location-popular-label">
        {{ t('popularCities') }}
      </div>

      <button type="button" (click)="selectLocation('Dhaka')">{{ t('dhaka') }}</button>
      <button type="button" (click)="selectLocation('Chattogram')">{{ t('chattogram') }}</button>
      <button type="button" (click)="selectLocation('Sylhet')">{{ t('sylhet') }}</button>
      <button type="button" (click)="selectLocation('Rajshahi')">{{ t('rajshahi') }}</button>
      <button type="button" (click)="selectLocation('Khulna')">{{ t('khulna') }}</button>

    </ng-container>

  </ng-container>

</div>

<div
  class="mobile-overlay"
  *ngIf="sidebarOpen"
  (click)="toggleSidebar()"
>
</div>

<div
  class="mobile-sidebar"
  *ngIf="sidebarOpen"
>

  <div class="sidebar-content">

    <app-sidebar
      (categoryClick)="onMobileCategory($event)">
    </app-sidebar>

  </div>

  <div class="sidebar-account">

    <a
  *ngIf="isLoggedIn()"
  (click)="logout(); sidebarOpen=false">
  <i class="fa-solid fa-right-from-bracket"></i>
  {{ t('logout') }}
</a>

<a
  *ngIf="!isLoggedIn()"
  routerLink="/login"
  (click)="sidebarOpen=false">
  <i class="fa-solid fa-right-to-bracket"></i>
  {{ t('login') }}
</a>
  </div>

</div>


<!-- =========================
     DESKTOP NAVBAR
========================= -->

<div class="navbar">


  <div
    class="desktop-menu-wrapper"
    (click)="$event.stopPropagation()"
  >

    <button
      type="button"
      class="desktop-menu-btn"
      (click)="toggleDesktopMenu($event)"
      aria-label="Open account menu"
    >
      <i class="fa-solid fa-bars"></i>
    </button>

    <div
  class="desktop-account-menu"
  *ngIf="desktopMenuOpen && !isMobile"
>

  <a
    routerLink="/"
    (click)="closeDesktopMenu()"
  >
    <i class="fa-solid fa-house"></i>
    <span>{{ t('home') }}</span>
  </a>

<a
  *ngIf="isLoggedIn() && !isAdmin()"
  routerLink="/account"
  (click)="closeDesktopMenu()"
>
  <i class="fa-solid fa-user"></i>
  <span>{{ t('account') }}</span>
</a>

  <a
    *ngIf="isAdmin()"
    routerLink="/admin/dashboard"
    (click)="closeDesktopMenu()"
  >
    <i class="fa-solid fa-user-shield"></i>
    <span>{{ t('adminDashboard') }}</span>
  </a>

</div>

  </div>


  <div class="left">


    <div
      class="brand"
      (click)="goHome()"
    >

      <img
        [src]="logoUrl"
        alt="Super Bangladesh Logo"
        class="brand-logo"
        (error)="onLogoError()"
      />

    </div>


    <div
  class="search"
  *ngIf="!isMobile"
>

      <input
        type="text"
        [(ngModel)]="searchText"
        (input)="search()"
        [placeholder]="t('searchProductsExample')"
      />


      <button
        *ngIf="searchText"
        type="button"
        class="clear-btn"
        (click)="clearSearch()"
      >
        ✕
      </button>


      <button
        type="button"
        class="search-btn"
        (click)="search()"
      >
        <i class="fa-solid fa-magnifying-glass"></i>
      </button>

    </div>


    <div class="location-wrapper">

      <button
        type="button"
        class="location-btn"
        (click)="toggleLocationMenu($event)"
      >

        <i class="fa-solid fa-location-dot"></i>

        <span>
          {{ getSelectedLocationLabel() }}
        </span>

        <i
          class="fa-solid fa-chevron-down location-arrow"
        >
        </i>

      </button>


      <div
        class="location-dropdown"
        [class.search-mode]="locationMenuStep === 'cities'"
        *ngIf="showLocationMenu"
        (click)="$event.stopPropagation()"
      >

        <!-- STEP 1: MAIN -->
        <ng-container *ngIf="locationMenuStep === 'main'">

          <button
            type="button"
            class="location-option"
            (click)="useCurrentLocationNavbar()"
            [disabled]="locatingCurrentLocation"
          >

            <i class="fa-solid fa-location-crosshairs"></i>

            <span *ngIf="!locatingCurrentLocation">
              {{ t('useMyLocation') }}
            </span>

            <span *ngIf="locatingCurrentLocation">
              {{ t('locatingYou') }}
            </span>

          </button>

          <button
            type="button"
            class="location-option"
            (click)="showCityList()"
          >

            <i class="fa-solid fa-circle city-dot-icon"></i>

            <span>
              {{ t('changeCity') }}
            </span>

          </button>

        </ng-container>

        <!-- STEP 2: CITY LIST -->
        <ng-container *ngIf="locationMenuStep === 'cities'">

          <button
            type="button"
            class="location-back"
            (click)="backToLocationMain()"
          >
            <i class="fa-solid fa-arrow-left"></i>
          </button>

          <div class="location-search-box">
            <i class="fa-solid fa-magnifying-glass"></i>
            <input
              type="text"
              [(ngModel)]="locationSearchText"
              (input)="onLocationSearchInput()"
              [placeholder]="t('searchYourArea')"
            />
          </div>

          <ng-container *ngIf="locationSearchText.trim().length >= 3">

            <div class="location-search-status" *ngIf="locationSearching">
              {{ t('searchingLocation') }}
            </div>

            <ng-container *ngIf="!locationSearching">

              <button
                type="button"
                class="location-search-result"
                *ngFor="let result of locationSearchResults"
                (click)="selectSearchResult(result)"
              >
                <i class="fa-solid fa-location-dot"></i>
                <span>{{ result.label }}</span>
              </button>

              <div
                class="location-search-status"
                *ngIf="locationSearchResults.length === 0"
              >
                {{ t('noLocationResults') }}
              </div>

            </ng-container>

          </ng-container>

          <ng-container *ngIf="locationSearchText.trim().length < 3">

            <div class="location-popular-label">
              {{ t('popularCities') }}
            </div>

            <button
              type="button"
              (click)="selectLocation('Dhaka')"
            >
              {{ t('dhaka') }}
            </button>


            <button
              type="button"
              (click)="selectLocation('Chattogram')"
            >
              {{ t('chattogram') }}
            </button>


            <button
              type="button"
              (click)="selectLocation('Sylhet')"
            >
              {{ t('sylhet') }}
            </button>


            <button
              type="button"
              (click)="selectLocation('Rajshahi')"
            >
              {{ t('rajshahi') }}
            </button>


            <button
              type="button"
              (click)="selectLocation('Khulna')"
            >
              {{ t('khulna') }}
            </button>

          </ng-container>

        </ng-container>

      </div>

      <div
        class="auto-location-confirm-desktop"
        *ngIf="showAutoLocationConfirm && !showLocationMenu"
      >
        <span>{{ t('autoLocationConfirmText') }} <strong>{{ getSelectedLocationLabel() }}</strong>?</span>

        <div class="auto-location-confirm-actions">
          <button type="button" (click)="dismissAutoLocationConfirm($event)">
            {{ t('yesCorrect') }}
          </button>
          <button type="button" class="fix" (click)="fixAutoLocation($event)">
            {{ t('notMyArea') }}
          </button>
        </div>
      </div>

    </div>

  </div>


  <div class="right">


    <div class="language-switcher">

      <button
        type="button"
        [class.active]="
          selectedLanguage === 'en'
        "
        (click)="changeLanguage('en')"
      >
        English
      </button>


      <span>
        |
      </span>


      <button
        type="button"
        [class.active]="
          selectedLanguage === 'bn'
        "
        (click)="changeLanguage('bn')"
      >
        বাংলা
      </button>

    </div>


    <a
      *ngIf="!isLoggedIn()"
      routerLink="/login"
    >
      {{ t('login') }}
    </a>


    <a
      *ngIf="isLoggedIn()"
      (click)="logout()"
    >
      {{ t('logout') }}
    </a>

  </div>

</div>


<!-- =========================
     FLOATING CART
========================= -->

<div
  class="floating-cart"
  (click)="openCartDrawer()"
>

  <div class="cart-top">

    <div class="cart-icon">
      <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 6V6.75H5.513C4.553 6.75 3.749 7.474 3.648 8.429L2.385 20.429C2.257 21.646 3.211 22.714 4.436 22.714H19.564C20.789 22.714 21.743 21.646 21.615 20.429L20.352 8.429C20.251 7.474 19.447 6.75 18.487 6.75H16.5V6C16.5 3.515 14.485 1.5 12 1.5C9.515 1.5 7.5 3.515 7.5 6ZM12 3.75C10.757 3.75 9.75 4.757 9.75 6V6.75H14.25V6C14.25 4.757 13.243 3.75 12 3.75ZM9 14.25C9 15.907 10.343 17.25 12 17.25C13.657 17.25 15 15.907 15 14.25V13.5C15 12.879 15.504 12.375 16.125 12.375C16.746 12.375 17.25 12.879 17.25 13.5V14.25C17.25 17.149 14.899 19.5 12 19.5C9.101 19.5 6.75 17.149 6.75 14.25V13.5C6.75 12.879 7.254 12.375 7.875 12.375C8.496 12.375 9 12.879 9 13.5V14.25Z"/>
      </svg>
    </div>

    <div class="cart-count">

      {{ cart.count() }}

      {{ t('items') }}

    </div>

  </div>


  <div class="price">
    ৳ {{ cart.getTotal() }}
  </div>

</div>


<!-- =========================
     FLOATING CHAT
========================= -->

<div class="chat-wrapper">


  <div
    class="chat-options"
    *ngIf="showChat"
  >


    <a
      [href]="'tel:' + chatContact.phone"
      class="chat-item call"
      [title]="t('call')"
    >
      <i class="fa-solid fa-phone"></i>
    </a>


    <a
      [href]="chatContact.messengerUrl"
      target="_blank"
      rel="noopener noreferrer"
      class="chat-item messenger"
      [title]="t('messenger')"
    >
      <i class="fa-brands fa-facebook-messenger"></i>
    </a>


    <a
      [href]="'https://wa.me/' + chatContact.whatsappNumber"
      target="_blank"
      rel="noopener noreferrer"
      class="chat-item whatsapp"
      [title]="t('whatsapp')"
    >
      <i class="fa-brands fa-whatsapp"></i>
    </a>


    <a
      *ngIf="chatContact.instagramUrl"
      [href]="chatContact.instagramUrl"
      target="_blank"
      rel="noopener noreferrer"
      class="chat-item instagram"
      [title]="t('instagram')"
    >
      <i class="fa-brands fa-instagram"></i>
    </a>

  </div>


  <button
    type="button"
    class="main-chat-btn"
    (click)="toggleChat()"
    [title]="t('chat')"
  >
    <i class="fa-solid fa-comment-dots"></i>
  </button>

</div>

<!-- =========================
     LOCATION OFF -> HELP MODAL
     (mobile + desktop উভয় জায়গা থেকেই
     "Use my current location"-এ location
     off থাকলে এই একই modal আসবে)
========================= -->

<div
  class="location-help-overlay"
  *ngIf="showLocationHelp"
  (click)="closeLocationHelp()"
>
</div>

<div
  class="location-help-modal"
  *ngIf="showLocationHelp"
  (click)="$event.stopPropagation()"
>

  <button
    type="button"
    class="location-help-close"
    (click)="closeLocationHelp()"
  >
    <i class="fa-solid fa-xmark"></i>
  </button>

  <div class="location-help-icon">
    <i class="fa-solid fa-location-crosshairs"></i>
  </div>

  <h3 class="location-help-title">
    {{ t('geolocationOffTitle') }}
  </h3>

  <p
    class="location-help-desc"
    *ngIf="locationHelpReason === 'denied'"
  >
    {{ t('geolocationDenied') }}
  </p>

  <p
    class="location-help-desc"
    *ngIf="locationHelpReason === 'unavailable'"
  >
    {{ t('geolocationUnavailable') }}
  </p>

  <p
    class="location-help-desc"
    *ngIf="locationHelpReason === 'timeout'"
  >
    {{ t('geolocationTimeout') }}
  </p>

  <p
    class="location-help-desc"
    *ngIf="locationHelpReason === 'unsupported'"
  >
    {{ t('geolocationNotSupported') }}
  </p>

  <ol
    class="location-help-steps"
    *ngIf="locationHelpReason !== 'unsupported'"
  >
    <ng-container *ngIf="isAndroid">
      <li>{{ t('geolocationStepsAndroid1') }}</li>
      <li>{{ t('geolocationStepsAndroid2') }}</li>
    </ng-container>

    <ng-container *ngIf="isIOS">
      <li>{{ t('geolocationStepsIOS1') }}</li>
      <li>{{ t('geolocationStepsIOS2') }}</li>
      <li>{{ t('geolocationStepsIOS3') }}</li>
    </ng-container>

    <ng-container *ngIf="isDesktop && (browserName === 'chrome' || browserName === 'edge' || browserName === 'opera' || browserName === 'samsung')">
      <li>{{ t('geolocationStepsChrome1') }}</li>
      <li>{{ t('geolocationStepsChrome2') }}</li>
    </ng-container>

    <ng-container *ngIf="isDesktop && browserName === 'firefox'">
      <li>{{ t('geolocationStepsFirefox1') }}</li>
      <li>{{ t('geolocationStepsFirefox2') }}</li>
    </ng-container>

    <ng-container *ngIf="isDesktop && browserName === 'safari'">
      <li>{{ t('geolocationStepsSafariDesktop1') }}</li>
      <li>{{ t('geolocationStepsSafariDesktop2') }}</li>
    </ng-container>

    <ng-container *ngIf="isDesktop && browserName === 'other'">
      <li>{{ t('geolocationStepsDesktop1') }}</li>
      <li>{{ t('geolocationStepsDesktop2') }}</li>
    </ng-container>
  </ol>

  <div class="location-help-actions">

    <button
      type="button"
      class="location-help-btn primary"
      *ngIf="isAndroid"
      (click)="openDeviceLocationSettings()"
    >
      <i class="fa-solid fa-gear"></i>
      {{ t('geolocationOpenSettings') }}
    </button>

    <button
      type="button"
      class="location-help-btn primary"
      *ngIf="canCopySettingsLink"
      (click)="copySettingsLink()"
    >
      <i class="fa-solid" [ngClass]="settingsLinkCopied ? 'fa-check' : 'fa-copy'"></i>
      {{ settingsLinkCopied ? t('geolocationLinkCopied') : t('geolocationCopySettingsLink') }}
    </button>

    <button
      type="button"
      class="location-help-btn primary"
      (click)="retryLocation()"
    >
      <i class="fa-solid fa-rotate-right"></i>
      {{ t('geolocationTryAgain') }}
    </button>

    <button
      type="button"
      class="location-help-btn"
      (click)="goToCityListFromHelp()"
    >
      {{ t('changeCity') }}
    </button>

  </div>

</div>

<!-- MOBILE BOTTOM NAV -->

<nav class="mobile-bottom-nav">

 <a
  routerLink="/"
  (click)="goHome()"
>
    <i class="fa-solid fa-house"></i>
    <span>{{ t('home') }}</span>
  </a>

  <button
    type="button"
    (click)="toggleSidebar()"
  >
    <i class="fa-solid fa-table-cells"></i>
    <span>{{ t('menu') }}</span>
  </button>

  <button
    type="button"
    (click)="openCartDrawer()"
    class="cart-nav"
  >
    <i class="fa-solid fa-cart-shopping"></i>

    <span
      class="nav-badge"
      *ngIf="cart.count()"
    >
      {{ cart.count() }}
    </span>

    <span>{{ t('cartLabel') }}</span>
  </button>

  <button
  type="button"
  (click)="toggleMobileSearch()"
>
    <i class="fa-solid fa-magnifying-glass"></i>
    <span>{{ t('search') }}</span>
  </button>

<!-- User -->
<a
  *ngIf="isLoggedIn() && !isAdmin()"
  routerLink="/account"
>
  <i class="fa-solid fa-user"></i>
  <span>{{ t('account') }}</span>
</a>

<!-- Admin -->
<a
  *ngIf="isAdmin()"
  routerLink="/admin/dashboard"
>
  <i class="fa-solid fa-user-shield"></i>
  <span>{{ t('admin') }}</span>
</a>
<a
  *ngIf="!isLoggedIn()"
  routerLink="/login"
>
  <i class="fa-solid fa-user"></i>
  <span>{{ t('login') }}</span>
</a>

</nav>